<div class="layout-col full">
  <span style="width: 90vw"></span>

  <app-work-station-type-detail
    class="flex"
    [workStationType]="workStationType"
    (close)="onClose($event)"
  >
  </app-work-station-type-detail>
</div>
